module.exports = __webpack_public_path__ + "static/media/mascot-mark-white.e9c9f1bd.svg";